const Api = global.Api;

try {
  var websocket_proxy = require("@/services/websocket.js").default;
} catch (err) {
  try {
    var websocket_proxy = require("@/framework/services/websocket.js").default;
  } catch (err) {}
}

export default {
  insert(credentials) {
    let wsp = websocket_proxy(
      "admin/crud/insert",
      "post",
      null,
      credentials,
      null
    );
    if (wsp) return wsp;

    return Api().post("admin/crud/insert", credentials);
  },
  loadAll(credentials) {
    let wsp = websocket_proxy(
      "admin/crud/loadAll",
      "post",
      null,
      credentials,
      null
    );
    if (wsp) return wsp;

    return Api().post("admin/crud/loadAll", credentials);
  },
  loadOne(credentials) {
    let wsp = websocket_proxy(
      "admin/crud/loadOne",
      "post",
      null,
      credentials,
      null
    );
    if (wsp) return wsp;
    return Api().post("admin/crud/loadOne", credentials);
  },
  loadOneView(credentials) {
    let wsp = websocket_proxy(
      "admin/crud/loadOneView",
      "post",
      null,
      credentials,
      null
    );
    if (wsp) return wsp;
    return Api().post("admin/crud/loadOneView", credentials);
  },
  loadZero(credentials) {
    let wsp = websocket_proxy(
      "admin/crud/loadZero",
      "post",
      null,
      credentials,
      null
    );
    if (wsp) return wsp;
    return Api().post("admin/crud/loadZero", credentials);
  },

  delete(credentials) {
    let wsp = websocket_proxy(
      "admin/crud/delete",
      "post",
      null,
      credentials,
      null
    );
    if (wsp) return wsp;
    return Api().post("admin/crud/delete", credentials);
  },
  update(credentials) {
    let wsp = websocket_proxy(
      "admin/crud/update",
      "post",
      null,
      credentials,
      null
    );
    if (wsp) return wsp;
    return Api().post("admin/crud/update", credentials);
  }
};
